import type { Locale } from '../i18n/messages';
import { registerContentParityTranslations } from './contentParityRegistry';

export async function loadContentParityTranslations(locale: Locale): Promise<void> {
  switch (locale) {
    case 'en':
      return;
    case 'es': {
      const { default: translations } = await import(
        '../i18n/generated/contentParityTranslations.es'
      );
      registerContentParityTranslations('es', translations);
      return;
    }
    case 'fr': {
      const { default: translations } = await import(
        '../i18n/generated/contentParityTranslations.fr'
      );
      registerContentParityTranslations('fr', translations);
      return;
    }
    case 'de': {
      const { default: translations } = await import(
        '../i18n/generated/contentParityTranslations.de'
      );
      registerContentParityTranslations('de', translations);
      return;
    }
    case 'pt': {
      const { default: translations } = await import(
        '../i18n/generated/contentParityTranslations.pt'
      );
      registerContentParityTranslations('pt', translations);
      return;
    }
    case 'ar': {
      const { default: translations } = await import(
        '../i18n/generated/contentParityTranslations.ar'
      );
      registerContentParityTranslations('ar', translations);
      return;
    }
    case 'zh-Hans': {
      const { default: translations } = await import(
        '../i18n/generated/contentParityTranslations.zhHans'
      );
      registerContentParityTranslations('zh-Hans', translations);
      return;
    }
  }
}
